import React from "react";
import mac from './images/home/macbook-pro.jpg'
function Service(){
    return(
        <div>
<section className="internal_wraper">
<div className="container">
<div className="row">
    <div className="col-12 mt-5 pt-5">
<h1 className="font-weight-bold">
Service
                            </h1>
                            <div className="internal-wrapper">
                <div className="model">
                   {/* Service */}
                </div>
                <div className="product-title">
                   Services
                </div>
                <div className="brief-discriptio">
                Designed and implemented both frontend and backend components of Web applications.
                </div>
                <div className="links">
                    <ul>
                        <li><a href="#">Hosting Websites</a></li>
                            <li><a href="#">housing the files, data, and content that make up a
                                website on a server that is connected to the Internet.</a></li>
                    </ul>
                </div>
                    {/* <div className="home1"><a href="#"><img src={mac1} alt="" /></a></div> */}
                    <div className="model">
                    <p>With Google map location your organization</p>
      
  </div>
  <div className="product-title">
      {/* MacBook-pro */}
  </div>
  <div className="brief-discriptio">
      {/* The best for the brightest */}
  </div>
  <div className="links">
      <ul>
          {/* <li><a href="#">Learn more</a></li> */}
          {/* <li><a href="#">Buy</a></li> */}
      </ul>
  </div>
                    <div className="home"><a href="#"><img src={mac} alt="" /></a></div>
            </div>                 
                            
    </div>
</div>
</div>
</section>
        </div>
    );
};

export default Service;